import { MarketButton, MarketDivider } from '@market/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UNSUBSCRIBE_VALUES } from '.';
import nonTranslatableStrings from 'utils/nonTranslatableStrings';
import useCdpPageTracking, {
  Client_Namespace,
} from 'utils/custom-react-hooks/useCdpPageTracking';
import { viewMarketingResubscribed } from 'services/tracking/cdp/events/singleClickMarketingPreferences';

interface ResubscribedProps {
  unsubscribedFrom: UNSUBSCRIBE_VALUES.MERCHANT | UNSUBSCRIBE_VALUES.GLOBAL;
  emailOptInId: string;
  obfuscatedEmail: string;
  merchantName: string;
  doResubscribe: Function;
  isResubscribing: boolean;
  isResubscribed: boolean;
}

const Resubscribed: React.FC<ResubscribedProps> = (props) => {
  const { t } = useTranslation();

  /* CDP page view tracking */

  useCdpPageTracking({
    properties: viewMarketingResubscribed(
      props.emailOptInId,
      'email',
      props.unsubscribedFrom === UNSUBSCRIBE_VALUES.MERCHANT
        ? 'merchant'
        : 'all'
    ),
    isLoading: false,
    didLoadingFail: false,
    client: Client_Namespace.UNSUBSCRIBE,
  });

  /* Content */

  return (
    <>
      <h2>
        {t('preference.components.unsubscribe.marketing.resubscribe.title')}
      </h2>
      <div>
        {t('preference.components.unsubscribe.marketing.resubscribe.content', {
          merchantName:
            props.unsubscribedFrom === UNSUBSCRIBE_VALUES.MERCHANT
              ? props.merchantName
              : nonTranslatableStrings.square,
        })}
      </div>

      <MarketDivider />

      <h3>{t('preference.components.loginCard.title.updatePreference')}</h3>

      <div>{t('unauthenticatedVerifyEmail.success.subtitle2')}</div>

      <MarketButton href={'/'} className={'mt-7'}>
        {t('unauthenticatedVerifyEmail.signIn')}
      </MarketButton>
    </>
  );
};

export default Resubscribed;
